/* eslint-disable */
import { AuthContext } from "contexts/authContext";
import { AuthStatus, IAuth } from "interfaces/IAuth";
import React from "react";
import { Redirect, Route } from "react-router-dom";

function ProtectedRoute({ component: Component, ...restOfProps }: any) {
  const { authStatus }: IAuth = React.useContext(AuthContext);

  if (authStatus !== AuthStatus.SignedIn) {
    return null;
  }

  return (
    <Route
      {...restOfProps}
      component={Component}
    />
  );
}

export default ProtectedRoute;